<template>
  <div>
    <div v-if="!ot.otPatrimoine">
      <div class="card mgt-20px">
        <div class="card-content has-text-centered pd-40px">
          <h1 class="title is-size-3">
            {{ $t('addEditOrdreTravailTech.patrimoine.noPat.title')}}
          </h1>
        </div>
      </div>
    </div>
    <div class="card mgt-20px" v-else>
      <div class="card-content">
        <div class="columns pdt-0">
          <div class="column is-2">
            <div class="is-position-relative height-151">
              <img
                :src="logo ? logo : '/static/img/default-placeholder.png'"
                class="image logo-img" alt="Logo"/>
            </div>
          </div>
          <div class="column is-9">
            <div class="columns is-multiline">
              <div class="column is-6 is-size-4 has-text-weight-bold pdb-0">
                <b-field>
                  <div>{{ $t('addEditOrdreTravailTech.patrimoine.emplacement.title',
                    { code: ot.otPatrimoine.emplacement.code }) }}</div>
                  <router-link-blank :to="{ name: 'c.gabed.emplacement-detailEmplacement',
                                      params: { id: ot.otPatrimoine.emplacement.id } }"
                                     icon="open-in-new"
                                     classMessage="mgl-10px"
                                     typeIcon="is-primary" sizeIcon="is-small">
                  </router-link-blank>
                </b-field>
              </div>
              <div class="column is-6 is-size-5 has-text-weight-bold pdb-0"
                   v-if="ot.otPatrimoine.dispositif">
                <b-field>
                  <div>
                    {{ $t('addEditOrdreTravailTech.patrimoine.dispositif.title',
                    { code: ot.otPatrimoine.dispositif.code }) }}
                  </div>
                  <router-link-blank :to="{ name: 'c.gabed.emplacement-detailDispositif',
                                      params: {
              idDispositif: ot.otPatrimoine.dispositif.id,
              id: ot.otPatrimoine.emplacement.id,
            } }"
                                     icon="open-in-new"
                                     classMessage="mgl-10px"
                                     typeIcon="is-primary" sizeIcon="is-small">
                  </router-link-blank>
                </b-field>
              </div>
              <div class="column is-6 is-size-5 has-text-weight-bold pdt-0"
                   v-if="ot.otPatrimoine.materiel">
                <b-field>
                  <div>
                    {{ $t('addEditOrdreTravailTech.patrimoine.materiel.title',
                    { code: ot.otPatrimoine.materiel.code }) }}
                  </div>
                  <router-link-blank :to="{ name: 'c.gabed.emplacement-detailMateriel',
                                      params: {
              idMateriel: ot.otPatrimoine.materiel.id,
              id: ot.otPatrimoine.emplacement.id,
            } }"
                                     icon="open-in-new"
                                     classMessage="mgl-10px"
                                     typeIcon="is-primary" sizeIcon="is-small">
                  </router-link-blank>
                </b-field>
              </div>
              <div class="column is-6 is-size-5 has-text-weight-bold pdt-0"
                   v-if="ot.otPatrimoine.face">
                <b-field>
                  <div>
                    {{ $t('addEditOrdreTravailTech.patrimoine.face.title',
                    { code: ot.otPatrimoine.face.code }) }}
                  </div>
                  <router-link-blank :to="{ name: 'c.gabed.emplacement-face',
                                      params: {
              id: ot.otPatrimoine.emplacement.id,
              idFace: ot.otPatrimoine.face.id,
            } }"
                                     icon="open-in-new"
                                     classMessage="mgl-10px"
                                     typeIcon="is-primary" sizeIcon="is-small">
                  </router-link-blank>
                </b-field>
              </div>
            </div>
            <div class="columns is-multiline">
              <div class="column is-4 has-text-default"
                   v-if="ot.otPatrimoine.dispositif">
                <div>
            <span>
              {{ $t('addEditOrdreTravailTech.patrimoine.dispositif.type') }}
            </span>
                  <span class="has-text-weight-bold">
              {{ getLibelleDispositifType }}
            </span>
                </div>
                <div>
            <span>
              {{ $t('addEditOrdreTravailTech.patrimoine.dispositif.support') }}
            </span>
                  <span class="has-text-weight-bold">
              {{ getLibelleDispositifSupport }}
            </span>
                </div>
                <div>
            <span>
              {{ $t('addEditOrdreTravailTech.patrimoine.dispositif.etat') }}
            </span>
                  <span class="has-text-weight-bold">
              {{ getEtatMontage }}
            </span>
                </div>
                <div class="columns mg-0" v-if="hasEmplacmentClient">
                  <span>
                    {{ $t('addEditOrdreTravailTech.patrimoine.emplacement.champs.client') }} :&nbsp;
                  </span>
                  <router-link-blank :to="{ name: 'c.bodac.clients/contacts-client',
                                        params: { id: ot.otPatrimoine.emplacement.client.id } }"
                                      :message="getClient"
                                      typeIcon="is-primary">
                  </router-link-blank>
                </div>
              </div>
              <div class="column is-4 has-text-default"
                   v-if="ot.otPatrimoine.materiel">
                <div>
            <span>
              {{ $t('addEditOrdreTravailTech.patrimoine.materiel.format') }}
            </span>
                  <span class="has-text-weight-bold">
              {{ getLibelleMaterielFormat }}
            </span>
                </div>
                <div>
            <span>
              {{ $t('addEditOrdreTravailTech.patrimoine.materiel.type') }}
            </span>
                  <span class="has-text-weight-bold">
              {{ getLibelleMaterielType }}
            </span>
                </div>
              </div>
              <div class="column is-4 has-text-default"
                   v-if="ot.otPatrimoine.dispositif || ot.otPatrimoine.emplacement">
                <b-field :label="$t('addEditOrdreTravailTech.patrimoine.dispositif.adresse')">
            <span> {{ ot.otPatrimoine.emplacementId
              ? ot.otPatrimoine.emplacement.adresse
              : ot.otPatrimoine.dispositif.adresse}} </span>
                </b-field>
              </div>
            </div>
          </div>
          <div class="column is-1 has-text-right mgv-auto" v-if="!isDetail">
            <b-tooltip
              :label="$t('addEditOrdreTravailTech.patrimoine.canNotChangePatrionine')"
              :active="canNotChangePatrionine"
              position="is-left">
              <a @click="$emit('deleteOtPatrimoine')"
                :class="{'disabled': canNotChangePatrionine}">
                <b-icon
                 :type="{'is-danger': !canNotChangePatrionine }"
                  icon="delete-forever"
                  :class="{'text-access-no-permission': canNotChangePatrionine}">
                </b-icon>
              </a>
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { ETAT_DISPOSITIF_PUBLICITAIRE, ETAT_DISPOSITIF_PUBLICITAIRE_MODULE_EMPLACEMENT } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import getLogoFromPatrimoine from '@/services/logistique/ordreTravail/tech/getLogo';
import {
  FABRICATION_DISPOSITIF, DISPOSITIF_FABRIQUE,
} from '@/configuration/logistique/typeOt/typeOtConfig';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    ot: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: false,
      default: false,
    },
    isUpdate: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      logo: null,
    };
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    getLibelleDispositifType() {
      if (!this.ot.otPatrimoine || (this.ot.otPatrimoine && !this.ot.otPatrimoine.dispositif)) {
        return '';
      }
      const dispositifTypeFind = this.parametre(PARAMETRES_KEYS.dispositifType).find((param) => {
        return param.id === this.ot.otPatrimoine.dispositif.dispositifTypeId;
      });
      return dispositifTypeFind ? dispositifTypeFind.libelle : '';
    },
    getLibelleDispositifSupport() {
      if (!this.ot.otPatrimoine || (this.ot.otPatrimoine && !this.ot.otPatrimoine.dispositif)) {
        return '';
      }
      const dispositifSupportFind = this.parametre(PARAMETRES_KEYS.dispositifSupport)
        .find((param) => {
          return param.id === this.ot.otPatrimoine.dispositif.dispositifSupportId;
        });
      return dispositifSupportFind ? dispositifSupportFind.libelle : '';
    },
    getEtatMontage() {
      if (!this.ot.otPatrimoine || (this.ot.otPatrimoine && !this.ot.otPatrimoine.dispositif)) {
        return '';
      }
      let listeEtat = ETAT_DISPOSITIF_PUBLICITAIRE;
      if (this.moduleEmplacementClientActive) {
        listeEtat = listeEtat.concat(ETAT_DISPOSITIF_PUBLICITAIRE_MODULE_EMPLACEMENT);
      }
      const etatFind = listeEtat.find((etat) => {
        return etat.value === this.ot.otPatrimoine.dispositif.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    hasEmplacmentClient() {
      return [FABRICATION_DISPOSITIF, DISPOSITIF_FABRIQUE]
        .includes(this.ot.typeOt?.actionInterventionOt)
          && this.ot.otPatrimoine?.emplacement?.client;
    },
    getClient() {
      if (!this.hasEmplacmentClient) {
        return '';
      }
      return this.ot.otPatrimoine.emplacement.client.nomCommercial;
    },
    getLibelleMaterielType() {
      if (!this.ot.otPatrimoine || (this.ot.otPatrimoine && !this.ot.otPatrimoine.materiel)) {
        return '';
      }
      const materielTypeFind = this.parametre(PARAMETRES_KEYS.materielType)
        .find((param) => {
          return param.id === this.ot.otPatrimoine.materiel.typeId;
        });
      return materielTypeFind ? materielTypeFind.libelle : '';
    },
    getLibelleMaterielFormat() {
      if (!this.ot.otPatrimoine || (this.ot.otPatrimoine && !this.ot.otPatrimoine.materiel)) {
        return '';
      }
      const materielFormatFind = this.parametre(PARAMETRES_KEYS.materielFormat)
        .find((param) => {
          return param.id === this.ot.otPatrimoine.materiel.formatId;
        });
      return materielFormatFind ? materielFormatFind.libelle : '';
    },
    canNotChangePatrionine() {
      return this.isUpdate && [FABRICATION_DISPOSITIF, DISPOSITIF_FABRIQUE]
        .includes(this.ot.typeOt?.actionInterventionOt);
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.dispositifSupport,
        PARAMETRES_KEYS.dispositifType,
        PARAMETRES_KEYS.materielType,
        PARAMETRES_KEYS.materielFormat,
      ]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
      ]);
      if (this.ot.otPatrimoine) {
        this.logo = await getLogoFromPatrimoine(
          this.ot.otPatrimoine,
          this.ot.societeId ? this.ot.societeId : this.societeActiveId,
        );
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
